
export default (theme) => ({
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
  },
  messageAvatar: {
    margin: theme.spacing(1),
    width: 75,
    height: 75,
  },
  messageAvatarIcon: { fontSize: 50 },
});
